import RouletteContainer from '~/componentsPage/Roulette/RouletteContainer';
import AlertContainer from '~/components/AlertContainer/AlertContainer';
import MediaContainer from '~/components/MediaContainer/MediaContainer';
import GlobalAvatarLightbox from '~/components/AvatarLightbox/GlobalAvatarLightbox';
// Websocket jest renderowany w App.tsx (jeden globalny socket dla całej aplikacji).
// Picker emotek jest wbudowany bezpośrednio w RouletteChat (własna, izolowana logika).

function RouletteAppContainer() {
  return (
    <div data-component="RouletteAppContainer">
      <RouletteContainer />

      {/* Niewidoczne kontenery */}
      <AlertContainer />
      <MediaContainer />
      <GlobalAvatarLightbox />
    </div>
  );
}

export default RouletteAppContainer;
